import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-metrics-normalized',
  templateUrl: './metrics-normalized.component.html',
  styleUrls: ['./metrics-normalized.component.scss']
})
export class MetricsNormalizedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
